export default __webpack_public_path__ + "static/media/tablet hours.19a54a83.svg";